import { useState } from 'react';
import { reviews } from '@/mocks/reviews';

export default function CommentSection() {
  const [currentIndex, setCurrentIndex] = useState(0);
  const review = reviews[currentIndex];

  const nextReview = () => setCurrentIndex((prev) => (prev + 1) % reviews.length);
  const prevReview = () => setCurrentIndex((prev) => (prev - 1 + reviews.length) % reviews.length);

  return (
    <section className="py-10 md:py-14 px-4 md:px-6 bg-background-100">
      <div className="flex flex-col lg:flex-row gap-8 lg:gap-12 max-w-6xl mx-auto">
        <div className="lg:w-[40%]">
          <div className="rounded-[24px] overflow-hidden h-64 md:h-80">
            <img
              src={review.author.avatar}
              alt={review.author.name}
              className="w-full h-full object-cover"
            />
          </div>
        </div>

        <div className="lg:w-[60%] flex flex-col justify-center space-y-6">
          <span className="text-xs font-medium text-foreground-400 tracking-wider whitespace-nowrap">
            ( 热门评论 )
          </span>

          <h3 className="text-2xl md:text-4xl font-heading font-bold text-primary-900 leading-tight">
            读者热评
            <br />
            <span className="text-foreground-300">大家怎么看这些大瓜？</span>
          </h3>

          <blockquote className="text-foreground-600 text-sm md:text-base leading-relaxed border-l-2 border-accent-300 pl-4">
            "{review.content}"
          </blockquote>

          <p className="text-sm font-semibold text-primary-900 whitespace-nowrap">
            — {review.author.name}
          </p>

          <div className="flex items-center gap-2 pt-2">
            <button
              onClick={prevReview}
              className="w-9 h-9 rounded-full border border-foreground-300/40 flex items-center justify-center text-foreground-500 hover:border-accent-400 hover:text-accent-500 transition-colors"
            >
              <i className="ri-arrow-left-s-line text-sm"></i>
            </button>
            <button
              onClick={nextReview}
              className="w-9 h-9 rounded-full bg-primary-900 flex items-center justify-center text-background-50 hover:bg-primary-800 transition-colors"
            >
              <i className="ri-arrow-right-s-line text-sm"></i>
            </button>
            <div className="flex items-center gap-1.5 ml-3">
              {reviews.map((_, i) => (
                <button
                  key={i}
                  onClick={() => setCurrentIndex(i)}
                  className={`w-2 h-2 rounded-full transition-all ${
                    i === currentIndex ? 'bg-accent-500 w-5' : 'bg-foreground-300/50'
                  }`}
                />
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}